
// import axios from 'axios';
import { ContextMenuNode } from 'types/Sapphire_dto';
import Vue, { PropType } from 'vue'

const ContextMenuItem = Vue.extend({
  name: "context-menu-item",
  props: {
      item: Object as PropType<ContextMenuNode>,
  },
  data() {
    return {
      // parameters: [] as String[],
    };
  },
  methods: {
    itemClicked(clickEvent: string, parameters?: string) {
      // console.log('In itemClicked '+ clickEvent + ': ' + parameters);
      if (parameters) {
        this.$emit('contextMenuItemClicked', clickEvent, parameters);
      }
      else {
        this.$emit('contextMenuItemClicked', clickEvent);
      }
    }
  },
});

export type ContextMenuItemRef = InstanceType<typeof ContextMenuItem>;
export default ContextMenuItem;

